<template>
    <div>
        <section class="form-section" v-if="coursesExists">
            <div class="form-section-heading">
                {{ trans('user_groups.headline.license_information') }} -
                {{
                    trans('licenses.label.required_licenses_with_amount', {
                        amount: requiredLicenseAmount,
                    })
                }}
            </div>

            <div class="form-row">
                <div class="form-row__col">
                    <label class="label" for="client">{{
                        trans('courses.label.debit_from')
                    }}</label>
                    <select
                        class="input"
                        name="client_id"
                        v-model="selectedClient"
                        @change="recalculateLicenseAmount()"
                    >
                        <option value="">{{
                            trans('courses.label.select')
                        }}</option>
                        <option
                            :value="client.id"
                            v-for="client in clients"
                            :key="client.id"
                            :disabled="
                                client.license_plan == 'license_plan_alpha' &&
                                    (client.license_amount == 0 ||
                                        requiredLicenseAmount >
                                            client.license_amount)
                            "
                        >
                            {{ client.prefixed_name }}
                            {{
                                client.license_plan == 'license_plan_alpha'
                                    ? '(' +
                                      trans('licenses.label.amount') +
                                      ': ' +
                                      client.license_amount +
                                      ')'
                                    : ''
                            }}
                        </option>
                    </select>

                    <input
                        type="hidden"
                        name="client_id"
                        v-model="selectedClient"
                        hidden
                    />
                </div>

                <div class="form-row__col">
                    <form-date
                        name="start_date"
                        :initial-date="new Date(Date.now())"
                        v-model="datepicker.startDate"
                        :min-date="minDate"
                    >
                        {{ trans('courses.label.start_date') }}
                    </form-date>
                </div>

                <div class="form-row__col">
                    <form-date
                        name="end_date"
                        v-model="datepicker.endDate"
                        :min-date="minDate"
                    >
                        {{ trans('courses.label.end_date') }}
                    </form-date>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="section-heading">
                {{ trans('user_groups.headline.user_list') }}
            </div>

            <div class="assignable-users">
                <select-vue-table
                    :table-data-route="
                        this.route(
                            'tenantapi.clients.user-groups.users.assign',
                            {
                                client: this.clientId,
                                user_group: this.userGroup.id,
                            }
                        )
                    "
                    :customColumns="[
                        'cls_column',
                        'id',
                        'full_name',
                        'role_trans',
                        'email',
                    ]"
                    :options="options"
                    type="checkbox"
                >
                    <colored-letter-square
                        slot="cls_column"
                        slot-scope="props"
                        :name="props.row.full_name"
                        :length="2"
                    >
                    </colored-letter-square>
                </select-vue-table>
            </div>

            <input
                type="text"
                :value="JSON.stringify(selectedUsers)"
                name="users"
                hidden
            />
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button
                    type="submit"
                    :disabled="
                        (currentLicenseAmount < 0 &&
                            selectedClient.license_plan ==
                                'license_plan_beta') ||
                        selectedUsers.length == 0 ||
                        (selectedClient == '' && coursesExists)
                            ? true
                            : false
                    "
                    class="btn btn--big btn--primary"
                >
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
var axios = require('axios');
import { EventBus } from '../eventbus';
import { Event } from 'vue-tables-2';
import { Pagination, PaginationEvent } from 'vue-pagination-2';

export default {
    props: ['clientId', 'userGroup', 'coursesExists'],

    data() {
        return {
            tableData: [],
            originalClients: [],
            clients: [],
            selectedClient: '',
            selectedUsers: [],
            currentLicenseAmount: 0,
            options: {
                headings: {
                    checkbox: '',
                    cls_column: '',
                    id: this.trans('user_groups.label.id'),
                    full_name: this.trans('user_groups.label.full_name'),
                    role_trans: this.trans('user_groups.label.role'),
                    email: this.trans('user_groups.label.email'),
                },
                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },
                sortable: [],
            },
            datepicker: {
                startDate: new Date(),
                endDate: null,
                preSelectedDate: new Date(),
            },
            minDate: new Date(Date.now()),
        };
    },

    computed: {
        requiredLicenseAmount() {
            return this.coursesExists * this.selectedUsers.length;
        },
    },

    methods: {
        /**
         * If license amount of selected debit client is not enough reset debit client selection.
         */
        resetDebitClientField() {
            this.getOriginalClientData();

            var client = this.clients.find(client => {
                return client.id == this.selectedClient;
            });

            if (client && client.license_amount) {
                let clientsLicenseAmount = client.license_amount;
                if (clientsLicenseAmount < this.requiredLicenseAmount) {
                    this.selectedClient = '';
                }
            }
        },

        getOriginalClientData() {
            // Deep copy clients object without any reference
            this.clients = JSON.parse(JSON.stringify(this.originalClients));
        },

        /**
         * Fetches clients which can be selected for debiting.
         */
        fetchClientsforDebitLicense() {
            axios
                .get(
                    this.route('tenantapi.clients.debit.clients', {
                        client: this.clientId,
                    })
                )
                .then(response => {
                    this.clients = response.data;

                    // Deep copy clients object without any reference
                    this.originalClients = JSON.parse(
                        JSON.stringify(response.data)
                    );
                })
                .catch(error => {
                    console.log(error);
                });
        },

        /**
         * Recalculate license amount after selecting debit client.
         */
        recalculateLicenseAmount() {
            this.getOriginalClientData();

            var client = this.clients.find(client => {
                return client.id == this.selectedClient;
            });

            if (client) {
                client.license_amount -= this.requiredLicenseAmount;
                this.currentLicenseAmount = client.license_amount;
            } else {
                this.currentLicenseAmount = 0;
            }
        },

        /**
         * Preselect own client as debit client
         */
        preSelectOwnClientAsDebitClient() {
            this.selectedClient = this.userGroup.client_id;
        },
    },

    created() {
        this.fetchClientsforDebitLicense();
        this.preSelectOwnClientAsDebitClient();
    },

    mounted() {
        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('selected', selectedUsers => {
            this.selectedUsers = selectedUsers;
            this.recalculateLicenseAmount();
        });
    },
};
</script>
